<template>
  <div>
    <NuxtPage />
    <div
      class="fixed bottom-18 right-4 z-40 flex flex-col items-center md:bottom-4 md:right-20"
    >
      <BaseTheQuestionButton />
    </div>
  </div>
</template>

<script setup></script>
